import React from 'react';
import PropTypes from 'prop-types';

const CoffeeTable = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      d="M5.589 14.803H2.5a.5.5 0 0 1-.5-.5v-2.246a.5.5 0 0 1 .5-.5h19.25a.5.5 0 0 1 .5.5v2.246a.5.5 0 0 1-.5.5h-1.807m-14.354 0L3.31 20.31a.5.5 0 0 0 .462.691h1.481a.5.5 0 0 0 .462-.309l2.436-5.888m-2.563 0h2.563m0 0h9.484m0 0 1.69 5.836a.5.5 0 0 0 .48.361h1.495a.5.5 0 0 0 .475-.657l-1.833-5.54m-2.307 0h2.307"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeWidth={0.6}
      d="M9.5 6.421s1.125-.9 0-1.5 0-1.5 0-1.5M7.5 6s1.125-.9 0-1.5 0-1.5 0-1.5"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.8}
      d="M11.421 7.421h.316c.335 0 .656.13.893.36.237.231.37.544.37.87 0 .327-.133.64-.37.871a1.28 1.28 0 0 1-.893.36h-.316m0-2.46H7v2.768c0 .327.133.64.37.87.237.231.558.361.893.361h1.895c.335 0 .656-.13.893-.36.237-.231.37-.544.37-.87V7.42Z"
    />
  </svg>
);

CoffeeTable.propTypes = {
  color: PropTypes.string
};

export default CoffeeTable;
